import { getQueue } from "../api/getQueue";

import { useReactQuery } from "components/RemoteData";

export const useGetQueue = (queueId: string, friendlyUrl: string) => {
  return useReactQuery(getQueueKey(queueId), () =>
    getQueue(queueId, friendlyUrl)
  );
};

export const getQueueKey = (queueId: string) => ["queue", queueId];
